const TeaNatural=[
    {
        id:1,
        title:"Імбирно - м‘ятний 0,450л",
        price:"79 грн",
        src: require('../img/tea.webp'),
        text:"імбир, м‘ята",
    },
    {
        id:2,
        title:"Цитрусовий 0,450л",
        price:"79 грн",
        src: require('../img/tea.webp'),
        text:"лимон, лайм, апельсин, м’ята",
    },
    {
        id:3,
        title:"Імбирно-цитрусовий 0,450л",
        price:"79 грн",
        src: require('../img/tea.webp'),
        text:" імбир, апельсин, лимон",
    }
    
]

export default TeaNatural;